import { debug as log } from 'debug';

const warn = log('bps-web:warn');
const error = log('bps-web:error');
const info = log('bps-web:log');

export const debug = { warn, error, info };

// export default debug;
